import { Module } from 'vuex';
import { RootState } from '../types';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { DeviceState } from './types';

export const state: DeviceState = {
  devices: [],
  search: '',
};

const namespaced: boolean = true;

export const device: Module<DeviceState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
